import { render, staticRenderFns } from "./modifyPassword.vue?vue&type=template&id=3000eba4&scoped=true"
import script from "./modifyPassword.vue?vue&type=script&lang=js"
export * from "./modifyPassword.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3000eba4",
  null
  
)

export default component.exports